export default __webpack_public_path__ + "static/news-8d0872f0b4bb48f8c95fb6a573e7431f.jpg";